module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik04OTYgMTI4cTIwOSAwIDM4NS41IDEwM3QyNzkuNSAyNzkuNSAxMDMgMzg1LjUtMTAzIDM4NS41LTI3OS41IDI3OS41LTM4NS41IDEwMy0zODUuNS0xMDMtMjc5LjUtMjc5LjUtMTAzLTM4NS41IDEwMy0zODUuNSAyNzkuNS0yNzkuNSAzODUuNS0xMDN6bTM4NCA4MjNxMzItMTggMzItNTV0LTMyLTU1bC01NDQtMzIwcS0zMS0xOS02NC0xLTMyIDE5LTMyIDU2djY0MHEwIDM3IDMyIDU2IDE2IDggMzIgOCAxNyAwIDMyLTl6IiBmaWxsPSIjZmZmIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/play-circle.svg
// module id = 303
// module chunks = 0